import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import { useFormik } from "formik";
import * as yup from "yup";
import axios from "axios";
import { toast } from "react-toastify";
import { AuthContext } from "../../auth/authContext";
import TextField from "@mui/material/TextField";
import Alert from "@mui/material/Alert";
import { createUser } from "../../API/ApiUsers";
import Autocomplete from "@mui/material/Autocomplete";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import NativeSelect from "@mui/material/NativeSelect";
import { ReactReduxContext } from "react-redux";
import { getEstados, getMunicipios } from "../../API/ApiEstadosMunicipios";
import {
  newContract,
  updateEtapaTres,
  updateEtapaUno,
} from "../../API/ApiContratos";
import { getServiciosContrato } from "../../API/ApiServicios";
import InfoIcon from "@mui/icons-material/Info";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import InputAdornment from "@mui/material/InputAdornment";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";
import Button from "@mui/material/Button";
import SendIcon from "@mui/icons-material/Send";

import { NumericFormat } from "react-number-format";
import { apiGetObtenerListasDePrecios, apiGetPaquetesRelacionadoenVPS, apiGetPaquetesVPS, apiPatchAsignarProductoServicioVPSaContrato } from "../../API/ApiProductosServiciosCobranza";
import { useLoading } from "../../contexts/LoadingContext";

const validationSchema = yup.object({
  idservicio: yup.string("Ingresa Servicio").required("Servicio requerido"),
  importe: yup.string("Ingresa importe").required("Importe requerido"),

  plazo: yup.string("Ingresa plazo").required("Plazo requerido"),
  fechaInicioPago: yup
    .string("Ingresa fecha inicio de pago")
    .required("Fecha requerida"),
  domicilioCobro: yup
    .string("Ingresa domicilio")
    .required("Domicilio requerido"),
  tipoPrecio: yup.string("Ingresa precio").required("Precio requerido"),
  diaDePago: yup
    .string("Ingresa día de pago")
    .required("Día de pago requerido"),
});

export const EditContratosEtapaTresComponent = (props) => {
  const { user, dispatch } = React.useContext(AuthContext);
  const { startLoading, stopLoading } = useLoading();
  const [isDisabled, setIsDisabled] = React.useState(false);

  const [servicios, setServicios] = React.useState([]);

  const [paquetesvps, setPaquetesvps] = React.useState([]);
  const [paqueteSeleccionadoFinalData, setPaqueteSeleccionadoFinalData] = React.useState({});
  const [listasDePrecios, setListasDePrecios] = React.useState([]);

  const [servicioSeleccionadoTexto, setServicioSeleccionadoTexto] =
    React.useState("");
  const [precioSeleccionadoTexto, setPrecioSeleccionadoTexto] =
    React.useState("");
  const [paqueteSeleccionado, setPaqueteSeleccionado] = React.useState(null);
  const [dataPaquetePreparada, setDataPaquetePreparada] = React.useState(null);

  React.useEffect(() => {
    getServiciosContrato(user).then((resultado) => {
      if (resultado.status == 200) {
        setServicios(resultado.data);
        setServicioSeleccionadoTexto(
          typeof props.finalData.etapaDos[0] === "undefined"
            ? ""
            : props.finalData.etapaDos[0].idservicio
        );
      } else {
        toast.error("No se han podido cargar los servicios.");
        setServicios([]);
      }
    });
  }, []);

  React.useEffect(() => {

    apiGetPaquetesVPS(user).then((resultado) => {
      if (resultado.status == 200) {


        resultado.data = resultado.data.filter((servicio) => servicio.esPaquete == true);

        debugger;
        setPaquetesvps(resultado.data);

      } else {
        toast.error("No se han podido cargar los paquetes VPS.");
        setPaquetesvps([]);
      }
    });
  }, []);

  // Preparar data cuando se selecciona un paquete
  React.useEffect(() => {
    if (paqueteSeleccionado) {
      const dataPaquete = {
        id: paqueteSeleccionado.id,
        nombre: paqueteSeleccionado.nombre,
        descripcion: paqueteSeleccionado.descripcion,
        precio: paqueteSeleccionado.osProductoServicioPrecios?.[0]?.precio || "0",
        sku: paqueteSeleccionado.sku,
        idtipops: paqueteSeleccionado.idtipops,
        permiteCambioPrecio: paqueteSeleccionado.permiteCambioPrecio,
        aplicaComision: paqueteSeleccionado.aplicaComision,
        // Puedes agregar más campos según necesites
      };

      setDataPaquetePreparada(dataPaquete);
      console.log("Paquete seleccionado preparado para enviar:", dataPaquete);

      // Aquí puedes llamar a tu API si es necesario
      // ejemplo: enviarPaqueteAPI(dataPaquete);
    }
  }, [paqueteSeleccionado]);


  React.useEffect(() => {

    apiGetPaquetesRelacionadoenVPS(user, props.finalData.etapaUno[0].id).then((resultado) => {

      if (resultado.status == 200) {
        setPaqueteSeleccionadoFinalData(resultado.data)
      }
      else {
        setPaqueteSeleccionadoFinalData({})
      }
    });

    apiGetObtenerListasDePrecios(user).then((resultado) => {
      debugger;
      if (resultado.status == 200) {
        setListasDePrecios(resultado.data)
      }
      else {
        setListasDePrecios([])
      }
    });





  }, [startLoading, stopLoading]);

  // Comparar paqueteSeleccionadoFinalData con paquetesvps y pre-seleccionar si coincide
  React.useEffect(() => {
    if (paqueteSeleccionadoFinalData && paqueteSeleccionadoFinalData.id && paquetesvps.length > 0) {
      const paqueteCoincidente = paquetesvps.find(
        (paquete) => paquete.id === paqueteSeleccionadoFinalData.id
      );
      if (paqueteCoincidente) {
        setPaqueteSeleccionado(paqueteCoincidente);
      }
    }
  }, [paqueteSeleccionadoFinalData, paquetesvps]);



  React.useEffect(() => {
    for (const servicio of servicios) {
      if (servicio.id == servicioSeleccionadoTexto) {
      }
    }
  }, [servicioSeleccionadoTexto]);

  // Función para enviar paquete a la API
  const enviarPaqueteAPI = async () => {
    if (!dataPaquetePreparada) {
      toast.error("No hay paquete seleccionado");
      return;
    }

    try {
      startLoading();
      setIsDisabled(true);

      let hola = dataPaquetePreparada;

      console.log("Enviando paquete a la API:", hola);

      let response = await apiPatchAsignarProductoServicioVPSaContrato(user, props.finalData.etapaUno[0].id, dataPaquetePreparada.id);

      if (response.status === 200 || response.status === 201) {
        toast.success("Paquete enviado correctamente a la API");
        console.log("Respuesta de la API:", response.data);
        // Opcionalmente, limpiar la selección después de enviar
        // setPaqueteSeleccionado(null);
        // setDataPaquetePreparada(null);
      } else {
        toast.error("Error al enviar el paquete");
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error(
        error.response?.data?.message ||
        "Error al enviar el paquete a la API"
      );
    } finally {
      stopLoading();
      setIsDisabled(false);
    }
  };

  const formik = useFormik({
    initialValues: {
      noContrato:
        (typeof props.finalData.etapaUno !== "undefined" &&
          props.finalData.etapaUno.length === 0) ||
          typeof props.finalData.etapaUno[0].noContrato === "undefined"
          ? ""
          : props.finalData.etapaUno[0].noContrato,
      idcontrato: props.contrato,
      idservicio:
        (typeof props.finalData.etapaDos !== "undefined" &&
          props.finalData.etapaDos.length === 0) ||
          typeof props.finalData.etapaDos[0].idservicio === "undefined"
          ? ""
          : props.finalData.etapaDos[0].idservicio,
      importe:
        (typeof props.finalData.etapaDos !== "undefined" &&
          props.finalData.etapaDos.length === 0) ||
          typeof props.finalData.etapaDos[0].importe === "undefined"
          ? ""
          : props.finalData.etapaDos[0].importe,

      plazo:
        (typeof props.finalData.etapaDos !== "undefined" &&
          props.finalData.etapaDos.length === 0) ||
          typeof props.finalData.etapaDos[0].plazo === "undefined"
          ? ""
          : props.finalData.etapaDos[0].plazo,
      fechaInicioPago:
        (typeof props.finalData.etapaDos !== "undefined" &&
          props.finalData.etapaDos.length === 0) ||
          typeof props.finalData.etapaDos[0].fechaInicioPago === "undefined"
          ? ""
          : props.finalData.etapaDos[0].fechaInicioPago,
      domicilioCobro:
        (typeof props.finalData.etapaDos !== "undefined" &&
          props.finalData.etapaDos.length === 0) ||
          typeof props.finalData.etapaDos[0].domicilioCobro === "undefined"
          ? ""
          : props.finalData.etapaDos[0].domicilioCobro,
      tipoPrecio:
        (typeof props.finalData.etapaDos !== "undefined" &&
          props.finalData.etapaDos.length === 0) ||
          typeof props.finalData.etapaDos[0].tipoPrecio === "undefined"
          ? ""
          : props.finalData.etapaDos[0].tipoPrecio,
      modoDePago:
        (typeof props.finalData.etapaDos !== "undefined" &&
          props.finalData.etapaDos.length === 0) ||
          typeof props.finalData.etapaDos[0].modoDePago === "undefined"
          ? "1"
          : props.finalData.etapaDos[0].modoDePago,
      tipoPrecio:
        (typeof props.finalData.etapaDos !== "undefined" &&
          props.finalData.etapaDos.length === 0) ||
          typeof props.finalData.etapaDos[0].tipoPrecio === "undefined"
          ? ""
          : props.finalData.etapaDos[0].tipoPrecio,
      diaDePago: 0,
      formaPago:
        (typeof props.finalData.etapaDos !== "undefined" &&
          props.finalData.etapaDos.length === 0) ||
          typeof props.finalData.etapaDos[0].formaPago === "undefined"
          ? "1"
          : props.finalData.etapaDos[0].formaPago,
      serieDeCobranza:
        (typeof props.finalData.etapaDos !== "undefined" &&
          props.finalData.etapaDos.length === 0) ||
          typeof props.finalData.etapaDos[0].serieDeCobranza === "undefined"
          ? "A"
          : props.finalData.etapaDos[0].serieDeCobranza,
      precioContado:
        (typeof props.finalData.etapaDos !== "undefined" &&
          props.finalData.etapaDos.length === 0) ||
          typeof props.finalData.etapaDos[0].precioContado === "undefined"
          ? "0"
          : props.finalData.etapaDos[0].precioContado,
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      /* if (
        props.finalData.restructura.totalPagosContratoAnterior[0]
          .totalPagosAnterior == null
      ) {
      } else {
        values.saldo =
          values.importe -
          parseFloat(
            props.finalData.restructura.totalPagosContratoAnterior[0]
              .totalPagosAnterior
          );
      }*/

      startLoading();
      setIsDisabled(true);
      updateEtapaTres(user, values, props.contrato).then((resultado) => {
        if (resultado.status == 200) {
          toast.success("Datos Finanzas Actualizados Correctamente");
          window.location.reload();
        } else {
          toast.error(resultado.message);
        }
        stopLoading();
        setIsDisabled(false);
      });
    },
  });

  return (
    <div className="container-fluid p-2">
      <div className="row">
        <div className="col-12">
          {isDisabled == true ? (
            <>
              <Alert className="mb-3" severity="info">
                Procesando información...
              </Alert>
            </>
          ) : null}
          <form onSubmit={formik.handleSubmit} className="">
            <div className="container-fluid g-0">
              <div className="row row-cols-md-1">
                <div className="col-md-3 my-3">
                  <FormControl fullWidth>
                    <InputLabel
                      variant="standard"
                      htmlFor="uncontrolled-native"
                      shrink={true}
                    >
                      Servicio
                    </InputLabel>
                    <NativeSelect
                      value={formik.values.idservicio}
                      onChange={(e) => {
                        setServicioSeleccionadoTexto(e.target.value);

                        formik.setFieldValue("idservicio", e.target.value);

                        formik.handleChange(e);
                      }}
                      disabled={isDisabled}
                      inputProps={{
                        name: "idservicio",
                        id: "uncontrolled-native",
                      }}
                    >
                      <option value={""}>Seleccionar Servicio</option>
                      {servicios.map((servicio, index) => (
                        <option value={servicio.id} key={index}>
                          {servicio.nombre} - {servicio.descripcion} -{" "}
                          {servicio.precioContado}
                        </option>
                      ))}
                    </NativeSelect>
                  </FormControl>
                  <br />
                  <br />
                  <div className="card">
                    <div className="card-body text-justify">
                      {servicios.map((servicios2, index) =>
                        servicios2.id == servicioSeleccionadoTexto ? (
                          <React.Fragment key={index}>
                            <strong> {servicios2.nombre}</strong>
                            <br />
                            <small>{servicios2.descripcion}</small>
                            <hr />
                            <FormControl>
                              <FormLabel id="demo-radio-buttons-group-label">
                                Seleccionar Precio
                              </FormLabel>
                              <RadioGroup
                                aria-labelledby="demo-radio-buttons-group-label"
                                name="radio-buttons-group"
                                onChange={(e) => {
                                  var hola = e.target.value;
                                  setPrecioSeleccionadoTexto(hola);

                                  var divisiones = hola.split("$", 2);
                                  formik.setFieldValue(
                                    "tipoPrecio",
                                    divisiones[0].slice(0, -1)
                                  );
                                  formik.setFieldValue(
                                    "importe",
                                    divisiones[1].slice(0, -1)
                                  );
                                }}
                              >
                                <FormControlLabel
                                  disabled={
                                    typeof props.finalData.etapaDos[0] ===
                                      "undefined"
                                      ? false
                                      : false
                                  }
                                  value={
                                    "Precio Lista:$" + servicios2.precioLista
                                  }
                                  control={<Radio />}
                                  label={"Precio Lista"}
                                />

                                <FormControlLabel
                                  disabled={
                                    typeof props.finalData.etapaDos[0] ===
                                      "undefined"
                                      ? false
                                      : false
                                  }
                                  value={
                                    "Promoción:$" + servicios2.precioPromocion
                                  }
                                  control={<Radio />}
                                  label={"Promoción"}
                                />
                              </RadioGroup>
                            </FormControl>
                          </React.Fragment>
                        ) : null
                      )}
                    </div>
                  </div>

                  <br />

                  <div className="col-12 my-3 p-4 border rounded" style={{ background: 'rgba(0,15,174,0.3)' }}>
                    <strong className="mb-3">Agregar Paquete VPS</strong>
                    <br />
                    <br />
                    <Autocomplete
                      options={paquetesvps}
                      getOptionLabel={(option) =>
                        option && typeof option === 'object'
                          ? `${option.nombre} (${option.sku}) - ${option.descripcion}`
                          : ''
                      }
                      value={paqueteSeleccionado}
                      onInputChange={(event, newInputValue, reason) => {
                        if (reason === 'clear') {
                          setPaqueteSeleccionado(null);
                        }
                      }}
                      onChange={(event, newValue) => {
                        setPaqueteSeleccionado(newValue);
                      }}
                      disabled={isDisabled}
                      renderOption={(props, option) => (
                        <li {...props} key={option.id} style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', whiteSpace: 'normal' }}>
                          <span><strong>{option.nombre}</strong> <span className="text-muted">({option.sku})</span></span>
                          <span style={{ fontSize: '0.9em', color: '#555' }}>{option.descripcion}</span>
                        </li>
                      )}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Buscar Paquete VPS"
                          variant="standard"
                          placeholder="Ingrese nombre del paquete..."
                          InputProps={{
                            ...params.InputProps,
                            style: {
                              ...params.InputProps?.style,
                              whiteSpace: 'nowrap',
                              overflowX: 'auto',
                              textOverflow: 'unset',
                              fontSize: '1.1em',
                              letterSpacing: '0.5px',
                              width: '100%',
                              minWidth: 0,
                              maxWidth: '100%',
                            },
                          }}
                          inputProps={{
                            ...params.inputProps,
                            style: {
                              ...params.inputProps?.style,
                              whiteSpace: 'nowrap',
                              overflowX: 'auto',
                              textOverflow: 'unset',
                              width: '100%',
                              minWidth: 0,
                              maxWidth: '100%',
                            },
                          }}
                        />
                      )}
                      noOptionsText="Sin coincidencias"
                      loadingText="Cargando..."
                      filterOptions={(options, state) => {
                        const filtered = options.filter((option) =>
                          option.nombre
                            .toLowerCase()
                            .includes(state.inputValue.toLowerCase()) ||
                          option.sku
                            .toLowerCase()
                            .includes(state.inputValue.toLowerCase()) ||
                          option.descripcion
                            .toLowerCase()
                            .includes(state.inputValue.toLowerCase())
                        );
                        return filtered;
                      }}
                    />

                    {/* Mostrar paqueteSeleccionadoFinalData si existe */}
                    {paqueteSeleccionadoFinalData && Object.keys(paqueteSeleccionadoFinalData).length > 0 && (
                      <div className="card mt-3 border-primary">
                        <div className="card-header bg-primary text-white py-2">
                          <strong>Paquete Asignado al Contrato</strong>
                        </div>
                        <div className="card-body p-3">
                          <h6 className="card-title mb-1">{paqueteSeleccionadoFinalData.nombre}</h6>
                          <small className="text-muted d-block mb-1">SKU: {paqueteSeleccionadoFinalData.sku}</small>
                          {paqueteSeleccionadoFinalData.descripcion && (
                            <p className="card-text small mb-2">{paqueteSeleccionadoFinalData.descripcion}</p>
                          )}
                          <div className="d-flex gap-3 mb-2">
                            {paqueteSeleccionadoFinalData.permiteCambioPrecio !== undefined && (
                              <small><strong>Cambio Precio:</strong> {paqueteSeleccionadoFinalData.permiteCambioPrecio ? 'Sí' : 'No'}</small>
                            )}
                            {paqueteSeleccionadoFinalData.aplicaComision !== null && paqueteSeleccionadoFinalData.aplicaComision !== undefined && (
                              <small><strong>Aplica Comisión:</strong> {paqueteSeleccionadoFinalData.aplicaComision ? 'Sí' : 'No'}</small>
                            )}
                          </div>
                          {Array.isArray(paqueteSeleccionadoFinalData.paqueteIncluye) && paqueteSeleccionadoFinalData.paqueteIncluye.length > 0 && (
                            <div className="mt-2">
                              <strong className="small">Incluye:</strong>
                              <ul className="list-group list-group-flush mt-1">
                                {paqueteSeleccionadoFinalData.paqueteIncluye.map((item, idx) => (
                                  <li key={item?.id ?? idx} className="list-group-item px-0 py-1" style={{ background: 'transparent' }}>
                                    {item?.sku && (
                                      <span className="badge bg-secondary me-2" style={{ fontSize: '0.7em' }}>{item.sku}</span>
                                    )}
                                    <strong style={{ fontSize: '0.85em' }}>{item?.nombre ?? ''}</strong>
                                    {item?.descripcion && (
                                      <div className="text-muted" style={{ fontSize: '0.8em' }}>{item.descripcion}</div>
                                    )}
                                  </li>
                                ))}
                              </ul>
                            </div>
                          )}
                        </div>
                      </div>
                    )}

                    {paqueteSeleccionado && (
                      <div className="card mt-3">
                        <div className="card-body">
                          <h6 className="card-title">{paqueteSeleccionado.nombre}</h6>
                          <small className="text-muted">
                            SKU: {paqueteSeleccionado.sku}
                          </small>
                          <p className="card-text small mt-2">
                            {paqueteSeleccionado.descripcion}
                          </p>
                          {paqueteSeleccionado.osProductoServicioPrecios?.length >
                            0 && (
                              <div className="mt-2">
                                <strong>Precio:</strong>
                                <span className="ms-2">
                                  ${paqueteSeleccionado.osProductoServicioPrecios[0]?.precio || "0"}
                                </span>
                              </div>
                            )}
                          {Array.isArray(paqueteSeleccionado.paqueteIncluye) && paqueteSeleccionado.paqueteIncluye.length > 0 && (
                            <div className="mt-3">
                              <strong>Incluye:</strong>
                              <ul className="list-group list-group-flush mt-1">
                                {paqueteSeleccionado.paqueteIncluye.map((item, idx) => (
                                  <li key={item?.id ?? idx} className="list-group-item px-0 py-1" style={{ background: 'transparent' }}>
                                    {item?.sku && (
                                      <span className="badge bg-secondary me-2" style={{ fontSize: '0.7em' }}>{item.sku}</span>
                                    )}
                                    <strong>{item?.nombre ?? ''}</strong>
                                    {item?.descripcion ? (
                                      <div className="text-muted" style={{ fontSize: '0.82em' }}>{item.descripcion}</div>
                                    ) : null}
                                  </li>
                                ))}
                              </ul>
                            </div>
                          )}
                          {dataPaquetePreparada && (
                            <div className="mt-3 p-2 bg-light rounded">
                              <div className="mt-2">
                                <Button
                                  variant="contained"
                                  color="success"
                                  size="small"
                                  fullWidth
                                  startIcon={<SendIcon />}
                                  onClick={enviarPaqueteAPI}
                                  disabled={isDisabled}
                                >
                                  Guardar Paquete VPS
                                </Button>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </div>


                <div className="col-md-9">
                  <div className="container-fluid p-2">
                    <div className="row">
                      <div className="col-md-4">
                        <NumericFormat
                          value={formik.values.importe}
                          allowLeadingZeros
                          thousandSeparator=","
                          size="small"
                          fullWidth
                          id="importe"
                          name="importe"
                          className="mb-3"
                          label="Importe $"
                          prefix={"$"}
                          customInput={TextField}
                          variant="standard"
                          allowedDecimalSeparators={["%"]}
                          onValueChange={(values) => {
                            console.log(values);

                            formik.setFieldValue("importe", values.value);
                          }}
                        />

                        <TextField
                          size="small"
                          fullWidth
                          id="importe"
                          name="importe"
                          label="Importe $"
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <AttachMoneyIcon />
                              </InputAdornment>
                            ),
                          }}
                          type={"number"}
                          className="d-none"
                          value={formik.values.importe}
                          onChange={formik.handleChange}
                          variant="standard"
                          error={
                            formik.touched.importe &&
                            Boolean(formik.errors.importe)
                          }
                          helperText={
                            formik.touched.importe && formik.errors.importe
                          }
                        />
                      </div>

                      <div className="col-md-4">
                        <NumericFormat
                          value={formik.values.precioContado}
                          allowLeadingZeros
                          thousandSeparator=","
                          size="small"
                          fullWidth
                          id="precioContado"
                          name="precioContado"
                          className="mb-3"
                          label="Precio Contado $"
                          prefix={"$"}
                          customInput={TextField}
                          variant="standard"
                          allowedDecimalSeparators={["%"]}
                          onValueChange={(values) => {
                            console.log(values);

                            formik.setFieldValue("precioContado", values.value);
                          }}
                        />
                      </div>

                      <div className="col-md-4">
                        <TextField
                          size="small"
                          fullWidth
                          id="plazo"
                          name="plazo"
                          label="Plazo"
                          type={"number"}
                          className="mb-3"
                          value={formik.values.plazo}
                          onChange={formik.handleChange}
                          variant="standard"
                          error={
                            formik.touched.plazo && Boolean(formik.errors.plazo)
                          }
                          helperText={
                            formik.touched.plazo && formik.errors.plazo
                          }
                          disabled={isDisabled}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-4">
                        <TextField
                          size="small"
                          fullWidth
                          id="fechaInicioPago"
                          name="fechaInicioPago"
                          label="Fecha Inicio Pago"
                          type={"date"}
                          className="mb-3"
                          InputLabelProps={{ shrink: true }}
                          value={formik.values.fechaInicioPago}
                          onChange={formik.handleChange}
                          variant="standard"
                          error={
                            formik.touched.fechaInicioPago &&
                            Boolean(formik.errors.fechaInicioPago)
                          }
                          helperText={
                            formik.touched.fechaInicioPago &&
                            formik.errors.fechaInicioPago
                          }
                          disabled={isDisabled}
                        />
                      </div>
                      <div className="col-md-8">
                        <TextField
                          size="small"
                          fullWidth
                          id="domicilioCobro"
                          name="domicilioCobro"
                          label="Domicilio Cobro"
                          type={"text"}
                          className="mb-3"
                          value={formik.values.domicilioCobro}
                          onChange={formik.handleChange}
                          variant="standard"
                          error={
                            formik.touched.domicilioCobro &&
                            Boolean(formik.errors.domicilioCobro)
                          }
                          helperText={
                            formik.touched.domicilioCobro &&
                            formik.errors.domicilioCobro
                          }
                          disabled={isDisabled}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <TextField
                          size="small"
                          fullWidth
                          id="tipoPrecio"
                          name="tipoPrecio"
                          label="Tipo de Precio"
                          type={"text"}
                          className="mb-3"
                          InputLabelProps={{ shrink: true }}
                          value={formik.values.tipoPrecio}
                          onChange={formik.handleChange}
                          variant="standard"
                          error={
                            formik.touched.tipoPrecio &&
                            Boolean(formik.errors.tipoPrecio)
                          }
                          helperText={
                            formik.touched.tipoPrecio &&
                            formik.errors.tipoPrecio
                          }
                          disabled={true}
                        />
                      </div>
                      <div className="col-md-6 d-none">
                        <TextField
                          size="small"
                          fullWidth
                          id="diaDePago"
                          name="diaDePago"
                          label="Día de pago"
                          type={"number"}
                          className="mb-3"
                          value={formik.values.diaDePago}
                          onChange={formik.handleChange}
                          variant="standard"
                          error={
                            formik.touched.diaDePago &&
                            Boolean(formik.errors.diaDePago)
                          }
                          helperText={
                            formik.touched.diaDePago && formik.errors.diaDePago
                          }
                          disabled={isDisabled}
                        />
                      </div>

                      <div className="col">
                        <FormControl fullWidth>
                          <InputLabel
                            variant="standard"
                            htmlFor="uncontrolled-native"
                            shrink={true}
                          >
                            Modo de Pago
                          </InputLabel>
                          <NativeSelect
                            value={formik.values.modoDePago}
                            onChange={formik.handleChange}
                            disabled={isDisabled}
                            defaultValue={"1"}
                            inputProps={{
                              name: "modoDePago",
                              id: "uncontrolled-native",
                            }}
                          >
                            <option value={"1"}>Semanal</option>
                            <option value={"2"}>Catorcenal</option>
                            <option value={"3"}>Quincenal</option>
                            <option value={"4"}>Mensual</option>
                          </NativeSelect>
                        </FormControl>
                      </div>

                      <div className="col">
                        <FormControl fullWidth>
                          <InputLabel
                            variant="standard"
                            htmlFor="uncontrolled-native"
                            shrink={true}
                          >
                            Forma de Pago
                          </InputLabel>
                          <NativeSelect
                            value={formik.values.formaPago}
                            onChange={formik.handleChange}
                            disabled={isDisabled}
                            defaultValue={"1"}
                            inputProps={{
                              name: "formaPago",
                              id: "uncontrolled-native",
                            }}
                          >
                            <option value={"1"}>Oficina</option>
                            <option value={"2"}>Cobranza</option>
                            <option value={"3"}>Tranferencia Bancaria</option>
                            <option value={"4"}>Oxxo</option>
                            <option value={"5"}>Página Web</option>
                          </NativeSelect>
                        </FormControl>
                      </div>

                      <div className="col">
                        <FormControl fullWidth>
                          <InputLabel
                            variant="standard"
                            htmlFor="uncontrolled-native"
                            shrink={true}
                          >
                            Serie de Cobranza
                          </InputLabel>
                          <NativeSelect
                            value={formik.values.serieDeCobranza}
                            onChange={formik.handleChange}
                            disabled={isDisabled}
                            inputProps={{
                              name: "serieDeCobranza",
                              id: "uncontrolled-native",
                            }}
                          >
                            <option value={"A"}>A</option>
                            <option value={"AA"}>AA</option>
                            <option value={"B"}>B</option>
                            <option value={"BB"}>BB</option>
                            <option value={"D"}>D</option>
                            <option value={"E"}>E</option>
                            <option value={"F"}>F</option>
                            <option value={"G"}>G</option>
                            <option value={"H"}>H</option>
                            <option value={"I"}>I</option>
                            <option value={"J"}>J</option>
                            <option value={"P"}>P</option>
                            <option value={"MA"}>MA</option>
                            <option value={"SM"}>SM</option>
                            <option value={"S"}>S</option>
                            <option value={"PA"}>PA</option>
                            <option value={"W"}>W</option>
                            <option value={null}>Sin Información</option>
                          </NativeSelect>
                        </FormControl>
                      </div>
                    </div>
                  </div>

                  {props.permisoParaEditar == true ? (
                    <>
                      <button
                        className="my-4 btn btn-success w-100 text-white"
                        type="submit"
                        disabled={isDisabled}
                      >
                        Guardar Finanzas
                      </button>
                    </>
                  ) : null}
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
